import React from 'react';
import { Input } from 'antd';
import ReferenceManagement from '../../components/admin/ReferenceManagement/ReferenceManagement';
import {
  fetchDepartements,
  createDepartement,
  updateDepartement,
  deleteDepartement,
} from '../../store/slices/referenceSlice';

const DepartementManagement: React.FC = () => {
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
   
  ];

  const formFields = [
    {
      name: 'nom',
      label: 'Nom',
      rules: [{ required: true, message: 'Le nom est obligatoire' }],
      component: <Input placeholder="Nom du département" />,
    },
    
  ];

  return (
    <ReferenceManagement
      type="departements"
      title="Gestion des départements"
      fetchAction={fetchDepartements}
      createAction={createDepartement}
      updateAction={updateDepartement}
      deleteAction={deleteDepartement}
      columns={columns}
      formFields={formFields}
    />
  );
};

export default DepartementManagement;